<style scoped>

</style>

<template>
  <mu-list-item>
    <mu-list-item-action>
      <mu-circular-progress mode="determinate" :value="uploadProgress" v-if="!processing"></mu-circular-progress>
      <mu-circular-progress v-else></mu-circular-progress>
    </mu-list-item-action>
    <mu-list-item-content>
      <mu-list-item-title>
        {{$t('notification.' + (processing ? 'process' : 'upload'), {
          object: upload.text
        })}}
      </mu-list-item-title>
    </mu-list-item-content>
  </mu-list-item>
</template>

<script>

// Components

// Library
import axios from "axios";

export default {
  name: 'UploadQueueItem',
  components: {

  },
  props: {
    upload: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      uploadProgress: 0,
      processing: false,
    }
  },
  computed: {
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
  },
  mounted() {
    this.startUpload();
  },
  watch: {
    
  },
  methods: {
    startUpload() {
      axios.post(this.$store.getters.urlApi + this.upload.url, this.upload.formData, {
        headers: {
          token: this.$store.state.auth.token
        },
        onUploadProgress: (progressEvent) => {
          this.uploadProgress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
        }
      ).then(res => {
        var uid = res.data.data.uid;
        this.processing = true;
        this.fetchJobProgress(uid);
      });
    },
    fetchJobProgress(uid) {
      this.interval = setInterval(() => {
        axios({
          method: 'get',
          url: this.$store.getters.urlApi + "job/progress/" + uid,
          headers: {
            token: this.$store.state.auth.token
          },
          }).then(response => {
            if(response.data.data.result) {
              if(response.data.data.failed) {
                this.onJobFailed(uid);
              } else {
                this.onJobDone(uid);
              }
            } else {
              
            }
          })
          .catch(err => {
            console.log(err.message)
          });
      }, 3000);
    },
    onJobDone(uid) {
      clearInterval(this.interval);
      this.$store.commit('triggerRefresh');
      this.$store.commit('uploadQueuePop', this.upload.uploadId);
    },
    onJobFailed(uid) {
      clearInterval(this.interval);
      this.$store.commit('triggerRefresh');
      this.$store.commit('uploadQueuePop', this.upload.uploadId);
    },
  },

}
</script>
